import { Image as Images } from 'primereact/image';  

const Image = ({...rest}) => {

    return (
        <Images {...rest} />
    )

};

export default Image;